import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import Numeral from 'numeral';
import {Collapse} from 'reactstrap';
import ReactMapGL, {Marker} from 'react-map-gl';
import PageIndicator from '../components/PageIndicator';
import ImageUpload from '../components/ImageUpload';
import {enToFa} from '../utils/NumberUtility';
import {startCreateAgencyAd} from '../actions/agencyAds';
import {startgetCitiesOfState} from '../actions/configs';

const AgencyRegister = (props) => {

    const stepTitles = {"1": "اطلاعات نمایندگی", "2": "اطلاعات تماس", "3": "اطلاعات تکمیلی"};

    // const [yearsUpdated, setYearsUpdated] = useState(false)
    const [company, setCompany] = useState("-1")
    const [companyError, setCompanyError] = useState(false)
    const [galleryTitle, setGalleryTitle] = useState("")
    const [galleryTitleError, setGalleryTitleError] = useState(false)
    const [ownerTitle, setOwnerTitle] = useState("")
    const [ownerTitleError, setOwnerTitleError] = useState(false)
    const [agencyCode, setAgencyCode] = useState("")
    const [agencyCodeError, setAgencyCodeError] = useState(false)
    const [isSelling, setIsSelling] = useState(false)
    const [hasServices, setHasServices] = useState(false)

    const [imageOne, setImageOne] = useState();
    const [imageTwo, setImageTwo] = useState();
    const [imageThree, setImageThree] = useState();
    const [imageFour, setImageFour] = useState();

    const firstRef = React.createRef();
    const secondRef = React.createRef();
    const thirdRef = React.createRef();
    const fourthRef = React.createRef();

    const [certificate, setCertificate] = useState();
    const [certificateError, setCertificateError] = useState(false);
    const [logo, setLogo] = useState();
    const [logoError, setLogoError] = useState(false);

    const certificateRef = React.createRef();
    const logoRef = React.createRef();

    const [state, setState] = useState("-1")
    const [stateError, setStateError] = useState(false)
    const [city, setCity] = useState("-1")
    const [cityError, setCityError] = useState(false)
    const [phoneNo, setPhoneNo] = useState("")
    const [phoneNoError, setPhoneNoError] = useState(false)
    const [faxNo, setFaxNo] = useState("")
    const [faxError, setFaxError] = useState(false)
    const [instagramId, setInstagramId] = useState("")
    const [instagramError, setInstagramError] = useState(false)
    const [email, setEmail] = useState("")
    const [emailError, setEmailError] = useState(false)
    const [address, setAddress] = useState("")
    const [addressError, setAddressError] = useState(false)
    const [description, setDescription] = useState("")

    const defaultLat = 35.709344
    const defaultLng = 51.371004
    const defaultZoom = 16
    const [position, setPosition] = useState({latitude: defaultLat, longitude: defaultLng, zoom: defaultZoom});

    

    const [isSending, setSending] = useState(false);
    const [step, setStep] = useState(1);

    const onPrevPressed = () => {
        switch (step) {
            case 2:
                setStep(1);
                break;
            case 3:
                setStep(2);
                break;
        }
    }

    const onNextPressed = () => {
        switch (step) {
            case 1:
                if (stepOneValidation()){
                    setStep(2)
                }
                break;
            case 2:
                if (stepTwoValidation()){
                    setStep(3);
                }
                break;
            case 3:
                onFinalizeForSend()
                break;
        }
    }

    const stepOneValidation = () => {
        let hasError = false;
        if (company === "-1") {
            setCompanyError(true)
            hasError = true
        } else {
            setCompanyError(false)
        }
        if (galleryTitle === "") {
            setGalleryTitleError(true)
            hasError = true
        } else {
            setGalleryTitleError(false)
        }
        if (ownerTitle === "") {
            setOwnerTitleError(true)
            hasError = true
        } else {
            setOwnerTitleError(false)
        }
        if (agencyCode === "") {
            setAgencyCodeError(true)
            hasError = true
        } else {
            setAgencyCodeError(false)
        }
        if (!certificate) {
            setCertificateError(true)
            hasError = true
        } else {
            setCertificateError(false)
        }
        if (!logo) {
            setLogoError(true)
            hasError = true
        } else {
            setLogoError(false)
        }
        return !hasError
    }

    const stepTwoValidation = () => {
        let hasError = false;
        if (state === "-1") {
            setStateError(true)
            hasError = true
        } else {
            setStateError(false)
        }
        if (city === "-1") {
            setCityError(true)
            hasError = true
        } else {
            setCityError(false)
        }
        if (phoneNo === "") {
            setPhoneNoError(true)
            hasError = true
        } else {
            setPhoneNoError(false)
        }
        if (address === "") {
            setAddressError(true)
            hasError = true
        } else {
            setAddressError(false)
        }
        return !hasError
    }

    const onFinalizeForSend = () => {
        let adBody = new FormData()
        if (company !== "-1") {
            adBody.append("company", company)
        }
        if (galleryTitle !== "") {
            adBody.append("galleryTitle", galleryTitle)
        }
        if (ownerTitle !== "") {
            adBody.append("ownerTitle", ownerTitle)
        }
        if (agencyCode !== "") {
            adBody.append("agencyCode", agencyCode)
        }
        adBody.append("isSelling", isSelling)
        adBody.append("hasServices", hasServices)
        if (!!imageOne) {
            adBody.append("image_1", imageOne)
        }
        if (!!imageTwo) {
            adBody.append("image_2", imageTwo)
        }
        if (!!imageThree) {
            adBody.append("image_3", imageThree)
        }
        if (!!imageFour) {
            adBody.append("image_4", imageFour)
        }
        if (!!certificate) {
            adBody.append("certificate", certificate)
        }
        if (!!logo) {
            adBody.append("logo", logo)
        }
        if (city !== "-1") {
            adBody.append("city", city)
        }
        if (phoneNo !== "") {
            adBody.append("phoneNo", phoneNo)
        }
        if (faxNo !== "") {
            adBody.append("faxNo", faxNo)
        }
        if (instagramId !== "") {
            adBody.append("instagramLink", instagramId)
        }
        if (email !== "") {
            adBody.append("email", email)
        }
        if (address !== "") {
            adBody.append("address", address)
        }
        if (description !== "") {
            adBody.append("description", description)
        }
        adBody.append("lat", position.latitude)
        adBody.append("lng", position.longitude)
        
        setSending(true)
        props.createAd(adBody)
        .then(({success, error}) => {
            if (success){
                props.history.push('/dashboard')
            } else {
                setSending(false)
            }
        })
    }

    const onCompanyChanged = (e) => {
        if (e.target.value !== "-1") {
            setCompany(e.target.value)
            setCompanyError(false)
        }
    }

    const onTitleChanged = (e) => {
        setGalleryTitle(e.target.value)
        setGalleryTitleError(false)
    }

    const onOwnerChanged = (e) => {
        setOwnerTitle(e.target.value)
        setOwnerTitleError(false)
    }

    const onAgencyCodeChanged = (e) => {
        setAgencyCode(e.target.value)
        setAgencyCodeError(false)
    }
    
    const onSellingChanged = (e) => {
        setIsSelling(e.target.checked)
    }
    
    const onServicesChanged = (e) => {
        setHasServices(e.target.checked)
    }
    
    const onDescriptionChanged = (e) => {
        setDescription(e.target.value)
    }
    
    const stepOne = () => {
        return (
            <>
                <select className={companyError ? "register__dropdown--error" : "register__dropdown"} onChange={onCompanyChanged} value={company}>
                    <option value="-1">برند تجاری نمایندگی</option>
                    {props.companies.map((type) => {
                        return (<option key={type.id} value={type.id}>{type.title}</option>)
                    })}
                </select>
                <input className={galleryTitleError ? "register__dropdown--error" : "register__dropdown"} value={galleryTitle} onChange={onTitleChanged} type="text" placeholder="عنوان نمایندگی"></input>
                <input className={ownerTitleError ? "register__dropdown--error" : "register__dropdown"} value={ownerTitle} onChange={onOwnerChanged} type="text" placeholder="نام مالک"></input>
                <input className={agencyCodeError ? "register__dropdown--error" : "register__dropdown"} value={agencyCode} onChange={onAgencyCodeChanged} type="text" placeholder="کد نمایندگی"></input>
                <label className="optimized__d-flex-class justify-content-start align-items-center">
                    <input type="checkbox" value={isSelling} onChange={onSellingChanged}/>
                    <span className="mr-2">فروش دارد</span>
                </label>
                <label className="optimized__d-flex-class justify-content-start align-items-center">
                    <input type="checkbox" value={hasServices} onChange={onServicesChanged}/>
                    <span className="mr-2">خدمات پس از فروش دارد</span>
                </label>

                <div className="optimized__d-flex-class flex-wrap align-items-stretch justify-content-between my-4">
                    <ImageUpload stylesClass="col-6 px-0" hasError={certificateError} placeholder="قرارداد نمایندگی یا جواز کسب" image={certificate} inputRefrence={certificateRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-certificate"/>
                    <ImageUpload stylesClass="col-6 px-0" hasError={logoError} placeholder="لوگوی نمایندگی" image={logo} inputRefrence={logoRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-logo"/>
                </div>
            </>
        )
    }

    const onStateValueChanged = (e) => {
        if (e.target.value !== "-1" && e.target.value !== state) {
            setState(e.target.value)
            props.fetchCities(e.target.value)
            setStateError(false)
            setCity("-1")
        }
    }

    const onCityValueChanged = (e) => {
        if (e.target.value !== "-1") {
            setCity(e.target.value)
            setCityError(false)
        }
    }

    const onPhoneNoChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)) {
            setPhoneNo(e.target.value)
            setPhoneNoError(false)
        }
    }

    const onFaxNoChanged = (e) => {
        setFaxNo(e.target.value)
    }

    const onInstagramIdChanged = (e) => {
        setInstagramId(e.target.value)
    }

    const onEmailChanged = (e) => {
        setEmail(e.target.value)
    }

    const onAddressChanged = (e) => {
        setAddress(e.target.value)
    }

    const stepTwo = () => {
        return (
            <>
                <select className={stateError ? "register__dropdown--error" : "register__dropdown"} value={state} onChange={onStateValueChanged}>
                    <option value="-1">استان</option>
                    {
                        props.state.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <select className={cityError ? "register__dropdown--error" : "register__dropdown"} value={city} onChange={onCityValueChanged}>
                    <option value="-1">شهر</option>
                    {
                        props.cities.map((el, idx) => (
                            <option key={idx} value={el.id}>{el.name}</option>
                        ))
                    }
                </select>
                <input className={phoneNoError ? "register__dropdown--error" : "register__dropdown"} value={phoneNo} onChange={onPhoneNoChanged} type="text" placeholder="تلفن ثابت"></input>
                <input className="register__dropdown" value={faxNo} onChange={onFaxNoChanged} type="text" placeholder="فکس"></input>
                <input className="register__dropdown" value={instagramId} onChange={onInstagramIdChanged} type="text" placeholder="آیدی اینستاگرام"></input>
                <input className="register__dropdown" value={email} onChange={onEmailChanged} type="text" placeholder="ایمیل"></input>
                <textarea className={`${addressError ? "about__text-area--error" : "about__text-area"} p-3 mb-3 mt-4`} type="text" value={address} onChange={onAddressChanged} rows="5" placeholder="آدرس" />
            </>
        )
    }

    const onViewportChanged = (viewport) => {
        setPosition({
            latitude: viewport.latitude,
            longitude: viewport.longitude,
            zoom: viewport.zoom
        })
    }

    const gototMyLocation = () => {
        navigator.geolocation.getCurrentPosition(position => {
            console.log("position", position);
            setPosition({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                zoom: 18
            })
        })
    }

    const stepThree = () => {
        return (
            <>
                <textarea className="about__text-area p-3 mb-3 mt-4" type="text" value={description} onChange={onDescriptionChanged} rows="5" placeholder="توضیحات" />
                <div className="optimized__d-flex-class flex-wrap align-items-stretch justify-content-between my-4">
                    <ImageUpload stylesClass="col-3 px-0" placeholder="تصویر اول" image={imageOne} inputRefrence={firstRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-img-one"/>
                    <ImageUpload stylesClass="col-3 px-0" placeholder="تصویر دوم" image={imageTwo} inputRefrence={secondRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-img-two"/>
                    <ImageUpload stylesClass="col-3 px-0" placeholder="تصویر سوم" image={imageThree} inputRefrence={thirdRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-img-three"/>
                    <ImageUpload stylesClass="col-3 px-0" placeholder="تصویر چهارم" image={imageFour} inputRefrence={fourthRef} onFileChanged={imageChooser} onCloseClicked={removeImage} identifier="file-upload-img-four"/>
                </div>
                <ReactMapGL
                    mapboxApiAccessToken="pk.eyJ1IjoiYXBwc3RhdGlzdGljaWFuIiwiYSI6ImNrYjF6bTh6ZzBjN2gyenBqOTd5dmJ0bDIifQ.b1MJuTbmP-biJSkEz-g8KA"
                    mapStyle="mapbox://styles/mapbox/outdoors-v11"
                    width="100%" height="40vh" latitude={position.latitude} longitude={position.longitude} zoom={position.zoom}
                    onViewportChange={onViewportChanged}
                    >
                        <Marker
                            latitude={position.latitude}
                            longitude={position.longitude}>
                                <span><i className="material-icons">location_on</i></span>
                        </Marker>
                </ReactMapGL>
                <button className="register__button flex-grow-1 px-1 py-3 mt-2 mb-3" onClick={gototMyLocation}>موقعیت فعلی من</button>
            </>
        )
    }

    const imageChooser = (e) => {
        // console.log("image chooser", e.target.value, e.target.files);
        if (e.target.files.length > 0 && !!e.target.value.match(/.(jpg|jpeg|png)$/)){
            switch (e.target.id) {
                case "file-upload-img-one":
                    setImageOne(e.target.files[0])
                    break;
                case "file-upload-img-two":
                    setImageTwo(e.target.files[0])
                    break;
                case "file-upload-img-three":
                    setImageThree(e.target.files[0])
                    break;
                case "file-upload-img-four":
                    setImageFour(e.target.files[0])
                    break;
                case "file-upload-certificate":
                    setCertificate(e.target.files[0])
                    break;
                case "file-upload-logo":
                    setLogo(e.target.files[0])
                    break;
            }
        }
    }

    const removeImage = (e) => {
        // console.log("remove item id", e.target.id, firstRef.current.value)
        switch (e.target.id) {
            case "remove_file-upload-img-one":
                setImageOne(undefined)
                firstRef.current.value = null;
                break;
            case "remove_file-upload-img-two":
                setImageTwo(undefined)
                secondRef.current.value = null;
                break;
            case "remove_file-upload-img-three":
                setImageThree(undefined)
                thirdRef.current.value = null;
                break;
            case "remove_file-upload-img-four":
                setImageFour(undefined)
                fourthRef.current.value = null;
                break;
            case "remove_file-upload-certificate":
                setCertificate(undefined)
                certificateRef.current.value = null;
                break;
            case "remove_file-upload-logo":
                setLogo(undefined)
                logoRef.current.value = null;
                break;
        }
    }

    const pageSwitcher = () => {
        switch (step) {
            case 1:
                return stepOne();
            case 2:
                return stepTwo();
            case 3:
                return stepThree();
        }
    }

    return (
        
        <div className="container-sm optimized__d-flex-class flex-column h-100 mt-0 px-0 pb-4 justify-content-start about overflow-patch">
            <h1 className="register__page-title">{stepTitles[step] || ""}</h1>
            <PageIndicator current={step}/>
            <div className="optimized__d-flex-class flex-column px-4 mx-4 pb-4 about__description overflow-reset">
                <div className="optimized__d-flex-class flex-column py-3">
                    {
                        pageSwitcher()
                    }
                </div>
                <div className="optimized__d-flex-class flex-row-reverse">
                    <button disabled={isSending} className="register__button--danger flex-grow-1 px-1 py-3 mx-1" disabled={step === 1} onClick={onPrevPressed}>مرحله قبل</button>
                    {step === 3 ? (
                        <button disabled={isSending} className="register__button flex-grow-1 px-1 py-3 mx-1" onClick={onNextPressed}>ثبت آگهی</button>
                    ) : (
                        <button className="register__button flex-grow-1 px-1 py-3 mx-1" onClick={onNextPressed}>مرحله بعد</button>
                    )}
                    
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state, props) => ({
    companies: state.agencyConfigs.companies,
    state: state.vehicleConfigs.general.state,
    cities: state.vehicleConfigs.cities
});

const mapDispatchToProps = (dispatch) => ({
    fetchCities: (state) => dispatch(startgetCitiesOfState(state)),
    createAd: (body) => dispatch(startCreateAgencyAd(body))
});

export default connect(mapStateToProps, mapDispatchToProps)(AgencyRegister);